"use client";

import type { FC, PropsWithChildren } from "react";
import SiteInfoContext, { type SiteInfo } from "./SiteInfoContext";

type Props = PropsWithChildren<{
  value: SiteInfo;
}>;

// Server-resolved request context (site/domain/language) for client
// components. Reading these from cookies or window at render time causes
// hydration mismatches — during SSR they are empty, in the browser they are
// not — so the root layout provides them once, identically on both sides.
const SiteInfoProvider: FC<Props> = ({ children, value }) => (
  <SiteInfoContext.Provider value={value}>{children}</SiteInfoContext.Provider>
);

export default SiteInfoProvider;
